import React from "react";
import {
  Cloud, Database, Boxes, Settings, ShieldCheck, Users, ArrowRight, Rocket,
  MoveRight, RefreshCw, Server, BrainCircuit, HardDriveDownload, PiggyBank,
  Laptop, KeyRound, Building2, HeartPulse, Landmark, ShoppingBag, Briefcase,
  Factory, Cpu, Globe, Network, Lock, LineChart, BarChart3, FileText, LifeBuoy,
  CheckCircle2, Layers, GitBranch, Workflow, Gauge, BadgeCheck, Sparkles, CreditCard,
} from "lucide-react";

const MAP = {
  Cloud, Database, Boxes, Settings, ShieldCheck, Users, ArrowRight, Rocket,
  MoveRight, RefreshCw, Server, BrainCircuit, HardDriveDownload, PiggyBank,
  Laptop, KeyRound, Building2, HeartPulse, Landmark, ShoppingBag, Briefcase,
  Factory, Cpu, Globe, Network, Lock, LineChart, BarChart3, FileText, LifeBuoy,
  CheckCircle2, Layers, GitBranch, Workflow, Gauge, BadgeCheck, Sparkles, CreditCard,
};

export default function Icon({ name, className = "", size = 24, strokeWidth = 1.6 }) {
  const Cmp = MAP[name] || Cloud;
  return <Cmp className={className} size={size} strokeWidth={strokeWidth} />;
}
